import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AppTokenService,
  AuthAccessTokenDetails,
  OauthAEMConfig,
  UserDataService
} from '@com-delta-idp/mnx-oauth';
import { EndpointKeysCommon } from '@com-delta-idp/mnx-sitewide-shared-utils';
import {
  ApiBuilder,
  AppConfigService,
  handleError,
  HttpHeadersPayload,
  HttpRequestMethods,
  IDP_APPS
} from '@com-delta-idp/mnx-utils';
import { from, Observable } from 'rxjs';
import { filter, shareReplay, switchMap } from 'rxjs/operators';
import { GetSavedTrips } from '../../model/get-saved-trips/get-saved-trips.interfaces';

@Injectable({
  providedIn: 'root'
})
export class GetSavedTripsService {
  _errorHandler = handleError.bind(this);
  private savedTrips$!: Observable<GetSavedTrips>;
  private timeout = 10000;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private appToken: AppTokenService,
    private userData: UserDataService
  ) {}

  getSavedTrips(): Observable<GetSavedTrips> {
    if (this.savedTrips$) {
      return this.savedTrips$;
    } else {
      this.savedTrips$ = this.init().pipe(shareReplay(1));
      return this.savedTrips$;
    }
  }

  init(): Observable<GetSavedTrips> {
    return this.getAccessToken().pipe(
      switchMap((token) => {
        return new ApiBuilder<undefined, GetSavedTrips>(
          this.http,
          this.appConfig
        )
          .app(IDP_APPS.HEADER)
          .endpointKey(EndpointKeysCommon.GET_SAVED_TRIPS_AWS_URL)
          .method(HttpRequestMethods['GET_HEADERS'])
          .httpHeaders(this.createRequestHeaders(token))
          .errorHandler(this._errorHandler)
          .timeOut(this.timeout)
          .library('SHARED_COMPONENTS_HEADER')
          .create();
      })
    );
  }

  createRequestHeaders(token: AuthAccessTokenDetails): HttpHeadersPayload {
    return {
      'Content-Type': 'application/json',
      appId: 'cus',
      channelId: 'ecom',
      Authorization: `Bearer ${token.access_token}`
    };
  }

  getToken(authConfig: OauthAEMConfig): Observable<AuthAccessTokenDetails> {
    return from(this.appToken.getAppToken(authConfig));
  }

  getAccessToken(): Observable<AuthAccessTokenDetails> {
    return this.userData.getAuthConfigContent().pipe(
      filter((config: OauthAEMConfig) => !!config),
      switchMap((config) => {
        this.timeout = config.MFA_TIMEOUT;
        const authCopy: OauthAEMConfig = {
          ...config,
          SCOPE_VALUE_RM: `${config.SCOPE_VALUE} ${config.SAVED_SEARCH_GRAPHQL_SCOPE_VALUE}`,
          CLIENT_ID_VALUE: config['HEADER_CLIENT_ID_VALUE']
        };
        return this.getToken(authCopy);
      }),
      filter((token) => !!token)
    );
  }
}
